import { render, staticRenderFns } from "./machine_tech.vue?vue&type=template&id=e980af0a&"
import script from "./machine_tech.vue?vue&type=script&lang=js&"
export * from "./machine_tech.vue?vue&type=script&lang=js&"
import style0 from "./machine_tech.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./machine_tech.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports